<template>
  <div v-if="this.searchResults" class="w-full" style="height: 600px">
    <l-map ref="mapRef" :zoom="zoom" :bounds="bounds" style="height: 600px">
      <l-tile-layer :url="url"></l-tile-layer>
      <l-circle-marker
        v-for="item in this.searchResults"
        :radius="3"
        :opacity="1"
        :key="item.id"
        :lat-lng="[item._geoLoc.lat, item._geoLoc.lng]"
      > 
        <l-popup
          class="space-y-2"
        >
          <span class="flex justify-center font-semibold text-gray-600" v-html="item.name">
            {{ item.name }}
          </span>
          <span class="flex items-center justify-center space-x-1 text-gray-500">
            <svg
              class="flex-shrink-0 w-4 h-4 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="truncate">{{item.location}}</span>
          </span>
          <a :href="item.route" class="flex justify-center underline tw-link hover:no-underline">View Profile</a>
        </l-popup>
      </l-circle-marker> 
    </l-map>
  </div>
</template>
<script>
import "leaflet/dist/leaflet.css";

const centerMapDefault = [37.7749, -93.4194];

export default {
  name: "SearchMap",
  
  props: {
    searchResults: {
      type: [Object, Array],
      required: false
    }
  },

  data() {
    return {
      zoom: 6,
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    };
  },

  computed: {
    center() {
      return this.searchResults.length
        ? this.searchResults[0]._geoLoc
        : centerMapDefault;
    },
    bounds() {
      let lat = [];
      let lng = [];
      let bounds = [
        [48.75, -122.47],
        [27.994, -81.760]
      ];
      
      if(!this.searchResults) {
        return bounds;
      }
      for (let item in this.searchResults) {
        lat.push(this.searchResults[item]._geoLoc.lat);
        lng.push(this.searchResults[item]._geoLoc.lng);
      }
      
      if (lat.length === 1) {
        bounds = [
          [lat[0] - 0.0055, lng[0] - 0.0055],
          [lat[0] + 0.0055, lng[0] + 0.0055]
        ];
      } else if(lat.length === 0) {
        return bounds;
      } else {
        bounds = [
          [Math.min.apply(null, lat), Math.min.apply(null, lng)],
          [Math.max.apply(null, lat), Math.max.apply(null, lng)]
        ];
      }
      return bounds;
    }
  },
};
</script>
